// import {Link} from 'react-router-dom';
import clsx from 'clsx';
import InputError from '../../common/components/alerts/InputError';
import {useI18n} from '../../common/providers/I18nProvider';
import {PageTitle} from '../../common/providers/PageDataProvider';
import useHelp from './useHelp';
import SubmitButton from '../auth/common/components/SubmitButton';
// import {routes} from '../../routing/routes';
import HelpModal from './HelpModal';
import PathComponent from '../../common/components/path/PathComponent';

const Help = () => {
	const {i18n} = useI18n();
	const {formik, nameIsInValid, messageIsInValid, canNotSubmit, loading, success, setShowSuccess, formKey} = useHelp();

	return (
		<>
			<div>
				<PageTitle>{i18n('HELP')}</PageTitle>
				<div className='block sm:hidden'>
					<PathComponent
						parents={[{label: i18n('GO.BACK'), link: 'dashboard'}]}

						// child={i18n('ACCOUNT.SETTINGS.REGISTRATION.HEADER')}
					/>
				</div>
				<div className='grid justify-center'>
					<form
						className='form p-5   md:mt-[100px]  bg-white  rounded'
						onSubmit={formik.handleSubmit}
						noValidate
						key={formKey}
					>
						<div className='mb-4 flex flex-col'>
							<label className='font-medium text-auth-black mb-2'>{i18n('TYPEINQUIRY')}</label>

							<input
								placeholder={i18n('TYPEINQUIRY')}
								{...formik.getFieldProps('typeOfInquiry')}
								name='typeOfInquiry'
								onChange={formik.handleChange}
								autoComplete='off'
								className={clsx(
									'bg-white text-auth-black/80 border border-black-80 rounded-lg py-3 px-4 text-black w-[290px] md:w-[353px]',
									{
										'border-red-400': nameIsInValid,
									},
									'focus:outline-none focus:border-primary',
								)}
							/>
							{nameIsInValid && <InputError error={formik.errors.typeOfInquiry} />}
						</div>
						<div className='mb-4 flex flex-col'>
							<label className='font-medium text-auth-black mb-2'>{i18n('INQUIRYMESSAGE')}</label>

							<textarea
								placeholder={i18n('INQUIRYMESSAGE')}
								{...formik.getFieldProps('inquiryContent')}
								name='inquiryContent'
								autoComplete='off'
								className={clsx(
									'bg-white text-auth-black/80 border border-black-80 rounded-lg py-3 px-4 text-black h-[111px]',
									{
										'border-red-400': messageIsInValid,
									},
									'focus:outline-none focus:border-primary',
								)}
							/>
							{messageIsInValid && <InputError error={formik.errors.inquiryContent} />}
						</div>
						<div className='flex gap-10 mt-[120px]'>
							<div className='w-full sm:w-full'>
								{/* <button type='reset'> */}
								<SubmitButton canNotSubmit={canNotSubmit} loading={loading}>
									{i18n('SEND')}
								</SubmitButton>
								{/* </button> */}
							</div>
						</div>
					</form>
				</div>
			</div>
			<HelpModal
				success={success}
				setShowSuccess={setShowSuccess}
				message={i18n('CONTACT.MESSAGE')}
				desc={i18n('CONTACT.DESC')}
				Okay={i18n('HELP.OK')}
			/>
		</>
	);
};

export default Help;
